import type { BalanceData, SupplyId } from "@highmarch/domain";
import { PaintedIcon, paintedIconHtml, paintedIconUrl } from "../featureIcons";

/** Each supply's painted icon (MP-06, tools/art/icons3d/supplies.py). */
const ICON: Readonly<Record<SupplyId, PaintedIcon>> = { warBanner: "supplyBanner", scoutsMap: "supplyMap", supplyWagon: "supplyWagon", rallyHorn: "supplyHorn" };

export function supplyIconUrl(id: SupplyId): string { return paintedIconUrl(ICON[id]); }
export function supplyIconHtml(id: SupplyId, cssPx: number): string { return paintedIconHtml(ICON[id], cssPx); }

/** The names from the data, kept once the supplies feature registers (lines that are given no balance read them). */
let names: ReadonlyMap<SupplyId, string> = new Map();
export function setSupplyNames(B: BalanceData): void { names = new Map(B.commerce.shop.supplies.items.map((x) => [x.id, x.name])); }

/** A supply's name from the data ("War Banner"); its id spelt out when the data has none. */
export function supplyName(B: BalanceData | null, id: SupplyId): string {
  return B?.commerce.shop.supplies.items.find((x) => x.id === id)?.name ?? names.get(id) ?? id.replace(/([A-Z])/g, " $1").replace(/^./, (c) => c.toUpperCase());
}

/** A reward chip for `n` of a supply (Daily Orders, event rewards): its icon, the count and its name. */
export function supplyChipHtml(B: BalanceData, id: SupplyId, n = 1, px = 15): string {
  return `<span class="rw sup">${supplyIconHtml(id, px)}${n > 1 ? `${n} ` : ""}<span class="u">${supplyName(B, id)}</span></span>`;
}
